<template>
    <div class="pages">
        <div class="header">{{ pageTitle }}</div>
        <div class="container">
            <div class="line" v-for="(item, i) in infoList" :key="i">
                <div class="business" @click="item.show = !item.show" v-if="!item.isHref">
                    <div class="icon"><img :src="item.icon"></div>
                    <div class="text">
                        <p><span class="text-indent">{{ item.title }}</span></p>
                        <p>{{ item.profile }}</p>
                    </div>
                    <div class="right" :class="{'right-rotate': show}">
                        <RightOutlined />
                    </div>
                </div>
                <div class="business" @click="handleInfoClick(item)" v-else>
                    <div class="icon"><img :src="item.icon"></div>
                    <div class="text">
                        <p><span class="text-indent">{{ item.title }}</span></p>
                        <p>{{ item.profile }}</p>
                    </div>
                    <div class="right">
                        <RightOutlined />
                    </div>
                </div>
                <transition name="bounce">
                    <div class="btn-line" v-show="item.show" v-if="item.isHref === false">
                        <div class="btn-btn" @click="handleMenuClick(items.path)" v-for="(items, j) in item.hrefList" :key="j">{{ items.name }}</div>
                    </div>
                </transition>
            </div>
        </div>
        <van-popup v-model:show="QRCodeVisible"><img :src="QRCodeSrc"></van-popup>
    </div>
</template>

<script>
import { ref, onMounted } from "vue"

const icon0 = require('@/assets/img/town_home_icon_0.png')
const icon1 = require('@/assets/img/town_home_icon_1.png')
const icon2 = require('@/assets/img/town_home_icon_2.png')
const icon3 = require('@/assets/img/town_home_icon_3.png')
const icon4 = require('@/assets/img/town_home_icon_4.png')
const icon5 = require('@/assets/img/town_home_icon_5.png')
const icon6 = require('@/assets/img/town_home_icon_6.png')
import {RightOutlined} from '@ant-design/icons-vue'
import {useRoute, useRouter} from "vue-router"
import { Popup } from 'vant'
import 'vant/es/popup/style'
const qrcode0 = require('@/assets/img/jyzCode.png')
const qrcode1 = require('@/assets/img/hgzQRCode.jpg')
export default {
    name: "TownHome",
    setup() {
        const route = useRoute()
        const router = useRouter()
        const funList = {
            '5167': [
                {icon: icon5, title: '农业社会化服务', profile: '更快更方便，省时省力', isHref: true, href: 'DemandInformationAdd', hrefList: [], show: false},
                {icon: icon6, title: '土地流转办理', profile: '线上签订提交，方便快捷', isHref: false, hrefList: [{name: '农村土地出租合同', path: 'rentContract'},{name: '农村土地入股合同 ', path: '#'}], show: false},
                {icon: icon2, title: '金融保险办理', profile: '专业机构，安全可靠', isHref: false, hrefList: [{name: '我要投保', path: 'toubao'},{name: '我要贷款', path: 'daikuan'},{name: '我要报灾', path: 'baozai'},{name: '补贴查询', path: 'butie'},], show: false},
                {icon: icon3, title: '林木采伐证办理', profile: '线上办理，方便快捷', isHref: false, hrefList: [{name: '委托书', path: 'shouquanweituoshu'},{name: '现场查验表', path: 'linmucaifabiao'},{name: '申请表 ', path: 'linmushenqingbiao'}], show: false},
                {icon: icon0, title: '动植物检疫申请', profile: '线上办理，方便快捷', isHref: true, href: '#', hrefList: [], show: false},
                {icon: icon4, title: '农产品质量监管', profile: '线上办理，方便快捷', isHref: true, href: '#', hrefList: [], show: false}
            ],
            '5172': [
                {icon: icon5, title: '农业社会化服务', profile: '更快更方便，省时省力', isHref: true, href: 'DemandInformationAdd', hrefList: [], show: false},
                {icon: icon6, title: '土地经营权证办理', profile: '线上签订提交，方便快捷', isHref: false,  hrefList: [{name: '经营权证申请', path: 'tudijingyingquan'},{name: '农产品质量监管', path: '#'}], show: false},
                {icon: icon2, title: '金融保险办理', profile: '专业机构，安全可靠', isHref: false, hrefList: [{name: '我要投保', path: 'toubao'},{name: '我要贷款', path: 'daikuan'},{name: '我要报灾', path: 'baozai'},{name: '补贴查询', path: 'butie'},], show: false},
                {icon: icon3, title: '林木采伐证办理', profile: '线上办理，方便快捷', isHref: false, hrefList: [{name: '委托书', path: 'shouquanweituoshu'},{name: '现场查验表', path: 'linmucaifabiao'},{name: '申请表 ', path: 'linmushenqingbiao'}], show: false},
                // {icon: icon1, title: '技术咨询', profile: '专业技术指导，线上报名', isHref: true, href: '#', hrefList: [], show: false},
                {icon: icon0, title: '动植物检疫申请', profile: '线上办理，方便快捷', isHref: true, href: '#', hrefList: [], show: false},
                // {icon: icon4, title: '农产品质量监管', profile: '线上办理，方便快捷', isHref: true, href: 'rentContract', hrefList: [], show: false}
            ],
        }
        const menuList = [
            {icon: icon5, title: '农业社会化服务', profile: '更快更方便，省时省力', isHref: true, href: 'DemandInformationAdd', hrefList: [], show: false},
            {icon: icon6, title: '土地流转办理', profile: '线上签订提交，方便快捷', isHref: false, hrefList: [{name: '农村土地出租合同', path: 'rentContract'},{name: '农村土地入股合同 ', path: 'stakeContract'}], show: false},
            {icon: icon6, title: '土地经营权证办理', profile: '线上签订提交，方便快捷', isHref: false,  hrefList: [{name: '经营权证申请', path: 'tudijingyingquan'},{name: '农产品质量监管', path: 'alert1'}], show: false},
            {icon: icon2, title: '金融保险办理', profile: '专业机构，安全可靠', isHref: false, hrefList: [{name: '我要投保', path: 'toubao'},{name: '我要贷款', path: 'daikuan'},{name: '我要报灾', path: 'baozai'},{name: '补贴查询', path: 'butie'},], show: false},
            {icon: icon3, title: '林木采伐证办理', profile: '线上办理，方便快捷', isHref: false, hrefList: [{name: '委托书', path: 'shouquanweituoshu'},{name: '现场查验表', path: 'linmucaifabiao'},{name: '申请表 ', path: 'linmushenqingbiao'}], show: false},
            {icon: icon0, title: '动植物检疫申请', profile: '线上办理，方便快捷', isHref: false, hrefList: [{name: '动物检疫证申报', path: 'alert0'},{name: '植物质量安全检测', path: '#'}], show: false},
        ]
        const infoList = ref([])
        const pageTitle = ref('')
        const QRCodeVisible = ref(false)
        const handleInfoClick = (info) => {
            if (info.isHref && info.href!=='#') {
                router.push({name: info.href})
            }
        }
        const QRCodeSrc = ref('')
        const handleMenuClick = (path) => {
            if (path !== 'alert0' && path !== 'alert1') {
                router.push({name: path})
            } else {
                console.log(path)
                if (path === 'alert0') {
                    QRCodeSrc.value = qrcode0
                    QRCodeVisible.value = true
                }
                if (path === 'alert1') {
                    QRCodeSrc.value = qrcode1
                    QRCodeVisible.value = true
                }
            }
        }
        onMounted(() => {
            // infoList.value = funList[route.query.townId]
            infoList.value = menuList
            pageTitle.value = route.query.name
        })
        return {
            infoList,
            pageTitle,
            QRCodeVisible,
            QRCodeSrc,
            handleInfoClick,
            handleMenuClick
        }
    },
    components: {
        RightOutlined,
        [Popup.name]: Popup,
    }
}
</script>

<style scoped lang="stylus">
.pages {
    width 100%
    height 100%
    background-color #F6F7FB
    .header {
        width 100%
        height 170px
        background-image url("../../../assets/img/town_home_bg.png")
        background-repeat no-repeat
        background-size 100% 100%
        line-height 170px
        text-align center
        font-size 22px
        color #FFF
    }
    .container {
        width 100%
        padding 16px 23px
        background-color #F6F7FB
        .line {
            width 100%
            margin-bottom 10px
            transition .5s
            .business {
                width 100%
                height 85px
                color #999999
                background-color #FFF
                box-shadow 0 0 30px rgba(0, 0, 0, 0.1)
                padding 0 25px
                display flex
                justify-content space-between
                align-items center
                .icon img {
                    width 45px
                    height 45px
                }
                .text {
                    width calc(100% - 100px)
                    .text-indent:after {
                        content ''
                        display block
                        width 100%
                        height 4px
                        background-color rgba(17, 153, 255, 0.3)
                        position absolute
                        left 0
                        bottom 4px
                    }
                }
                .text p:first-child {
                    color #333333
                    font-size 16px
                    position relative
                }
                .text p:first-child span {
                    display inline-block
                    position relative
                }
                .text p:last-child {
                    font-size 12px
                }
                .right {
                    transition .5s
                    transform rotateZ()(0deg)
                }
                .right-rotate {
                    transform rotateZ(90deg)
                }
            }
            .btn-line {
                width 100%
                height 45px
                margin-top 10px
                display flex
                flex-wrap wrap
                justify-content space-evenly
                .btn-btn {
                    width auto
                    height 100%
                    padding 0 10px
                    line-height 45px
                    text-align center
                    color #39BFB3
                    font-size 13px
                    box-shadow 0 3px 6px rgba(0, 0, 0, 0.16)
                    border-radius 8px
                    background #FFFFFF
                }
            }
        }
    }
}
</style>
<style>
.bounce-enter-active {
    animation: bounce-in .5s;
}
.bounce-leave-active {
    animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1);
    }
    100% {
        transform: scale(1);
    }
}
</style>